export default __webpack_public_path__ + "ae2caa99edc9662ab687da82d0cf893d.xlsx";